//PERMISOS EN USO
export function isAdmin(actualRole){
    if ((actualRole?.name && actualRole.name.toLowerCase() === "admin") || (actualRole?.name && actualRole.name.toLowerCase() === "administrador")){
      return true;
    }
    return false
  }

  export function isMaster(actualRole){
    if (actualRole?.name &&actualRole.name.toLowerCase() === "master"){
      return true;
    }
    return false
  }

  export function isEditor(actualRole){
    if (actualRole?.name && actualRole.name.toLowerCase() === "editor"){
      return true;
    }
    return false
  }

  export function isReviewer(actualRole){
    const name = actualRole?.name?.toLowerCase();
    if (name === "reviewer" || name === "revisor"){
      return true;
    }
    return false
  }
    
/*
export function isMaster(actualRole) {
  if (!actualRole || !actualRole.name) return false;
  return actualRole.name.toLowerCase() === "master";
}*/
  //PERMISOS EN USO
  export function hasPermission(permissionsActive, roleId, module, action) { 
    let founded = false;
    if (permissionsActive){
      permissionsActive.forEach((i) => {
        if (roleId === i.role && module === i.module && action === i.action ){
          founded = true;
          return;
        }
      });
      if (founded === true) {
        return true;
      }
    } else {
      return false;
    }
  }